import type { EventLogEntry } from '../../types/council';

// Maps a log entry's target to the ChatMap node key (turnKey = the USER message id
// the node is keyed on; node ids are `stack-${turnKey}` / `group-stack-${turnKey}`).
export function logTargetToTurnKey(entry: EventLogEntry): string | null {
  const t = entry.target as Record<string, unknown>;
  const pick = (...keys: string[]): string | null => {
    for (const k of keys) {
      const v = t[k];
      if (typeof v === 'string' && v) return v;
    }
    return null;
  };
  switch (entry.event_type) {
    case 'turn_added': return pick('message_id', 'parent_message_id');
    case 'trail_forked': return pick('from_message_id');
    case 'artifact_created': return pick('source_turn_id', 'message_id');
    case 'cascade_depth_exceeded':
    case 'budget_overshoot': return pick('turn_message_id', 'trigger_parent_message_id');
    case 'merge_completed':
    case 'merge_turn_failed': return pick('message_id', 'camp_id');
    default: return pick('message_id', 'turn_message_id', 'from_message_id');
  }
}
